import React from "react";
import BondGeneralInformationBase from "../../../../features/bonds/shared/components/BondGeneralInformationBase";
import { GENERAL_INFORMATION_CONFIG } from "../../../../features/bonds/shared/generalInformationConfig";
import { RETRIEVE_GLOBAL_DATA_ROLE_DISABLED } from "./bondRetrieveSharedPropTypes";

const ProbateGeneralInformation = (props) => (
  <BondGeneralInformationBase
    cfg={GENERAL_INFORMATION_CONFIG.probate.retrieval}
    {...props}
  />
);

ProbateGeneralInformation.propTypes = RETRIEVE_GLOBAL_DATA_ROLE_DISABLED;

export default ProbateGeneralInformation;
